module.exports = __webpack_public_path__ + "./fonts/AvenirNextLTPro-Regular.otf";